import { ShowErrorWay } from "./calculator/utils.js";


/*
 *  To define new field type create class which extends Field class
 */
class Field {
    constructor(selectorOrElem, options) {
        this.elem = $(selectorOrElem);
        this.options = options;
        this.defaultGetValue = options && 'defaultGetValue' in options ? options.defaultGetValue : null;
        this.init();
        this.valid = true;
        this.deleted = false;
        this.isDynamic = false;
        this._ignore = false;
    }

    // this method is required for matching type with class
    static keyName() { return ''; }

    getValue() { return undefined; }
    setValue(v) { }

    // this method is required for automatic calculation of defaultValue
    getClearValue() { return this.getValue(); }

    // this method is required for automatic export build
    getExportValue() { return this.getValue(); }

    // additional field setup
    init() { }

    // for silent check (send sender as argument of function f)
    onChange(f) {
        let self = this;
        this.elem.change(function (e) { f(self.elem[0]); });
        if (this.options && this.options.keyup) {
            this.elem.keyup(function (e) { f(self.elem[0]); });
        }
        return this.elem;
    }

    // allows showing reset button for ignored fields
    showReset() { return false; }

    // for auto detecting type
    static detect(elem) { return false; }

    errorIsVisible() { return this.elem.hasClass('err') || this.elem.find('.err').length > 0; }
    isFilled() { return this.getClearValue() !== this.defaultValue; }


    delete() {
        this.deleted = true;
    }

    get ignore() { return this._ignore; }
    set ignore(val) { this._ignore = val; }

    clearErrors() {
        const errClassElem = (this.params_.errClassElem === undefined ? this.elem : $(this.params_.errClassElem));
        errClassElem.removeClass('err');
        if (this.params_.errors !== undefined) {
            this.params_.errors.forEach(function (err) {
                if (err.errClassElem !== undefined)
                    $(err.errClassElem).removeClass('err');
                $(err.selector).hide();
            });
        }
    }

    reset(params) {
        params = params || {};
        if (!params.keepValue) {
            this.setValue(this.defaultValue);
        }
        if (!params.keepErrors) {
            this.clearErrors();
        }
    }

    check(autoValidation, sender, phase, loud ) {
        if (phase < 2) {
            const silent = autoValidation && sender != this.elem[0] && !loud;
            const self = this.elem[0];
            let valid = true;
            if (this.params_.errors !== undefined) {
                const handler = (this.params_.showErrorWay == ShowErrorWay.SHOW_ALL ? 'forEach' : 'some');
                const v = this.getValue();
                const errClassElem = (this.params_.errClassElem === undefined ? this.elem : $(this.params_.errClassElem));
                if (!silent) this.clearErrors();
                this.params_.errors[handler](function (err) {
                    if (!err.check(v, autoValidation)) {
                        if (!silent) {
                            $(err.selector).show();
                            // fix for shadow DOM in ie
                            if (window.document.documentMode && self.tagName == "SUMMARY-INPUT")
                                $(err.selector).css('display', 'block');
                            if (err.errClassElem !== undefined)
                                $(err.errClassElem).addClass('err');
                            else
                                errClassElem.addClass('err');
                        }
                        valid = false;
                        return true;
                    }
                });
            }
            return valid;
        }
        return true;
    };
}


class _BaseObjectField extends Field {
    getClearValue() { return tools.deepcopy(this.elem[0].value); }
    getValue() { return this.elem.val(); }
    setValue(v) { this.elem.val(v); }
    getExportValue() { return this.elem.val(); }
    isFilled() {
        const clearValue = this.getClearValue();
        for (const key in clearValue) {
            if (clearValue[key] !== this.defaultValue[key])
                return true;
        }
        return false;
    }
}


class NumberField extends Field {
    static keyName() { return ''; }
    getClearValue() { return this.elem.val() === "" ? "" : this.getValue(); }
    setValue(v) { this.elem.val(v); }
    onChange(f) {
        let self = this;
        if (window.document.documentMode) {
            this.elem.blur(function (e) { f(self.elem[0]); });
        } else {
            this.elem.change(function (e) { f(self.elem[0]); });
        }
        if (this.options && this.options.keyup) {
            this.elem.keyup(function (e) { f(self.elem[0]); });
        }
        return this.elem;
    }
    setupNumberInput(isFloat, props, disableProps) {
        let self = this;
        disableProps = disableProps || [];
        if (this.options) {
            ["maxVal", "minVal", "precision"].forEach(function (name) {
                if (self.options[name] !== undefined) {
                    if (disableProps.indexOf(name) >= 0) {
                        console.error(`Prop ${name} is not allowed in field of type "${self.keyName()}"`);
                    }
                    else {
                        props[name] = self.options[name];
                    }
                }
            });
        }
        const $field = this.elem.closest('div.field-div');
        $field.find("input.base-input").inputFilter(isFloat, props);
        this.elem.focusin(function () {
            this.classList.remove('err');
            $field.find(".error-text").hide();
        });
    }
}


class CountField extends NumberField {
    static keyName() { return 'count'; }
    getValue() { return this.elem.val() ? tools.parseLocaleInt(this.elem.val()) : this.defaultGetValue; }
    init() { this.setupNumberInput(false, {}, ['precision']); }
}


class YearField extends NumberField {
    static keyName() { return 'year'; }
    getValue() { return this.elem.val() ? tools.parseLocaleInt(this.elem.val()) : this.defaultGetValue; }
    init() { this.setupNumberInput(false, { allowSpaces: false, maxLength: 4 }, ['precision']); }
}


class PeriodField extends NumberField {
    static keyName() { return 'period'; }
    getValue() { return this.elem.val() ? tools.parseLocaleInt(this.elem.val()) : this.defaultGetValue; }
    init() { this.setupNumberInput(false, { allowSpaces: false }, ['precision']); }
}


class FloatField extends NumberField {
    static keyName() { return 'float'; }
    getValue() { return this.elem.val() ? tools.parseLocaleFloat(this.elem.val()) : this.defaultGetValue; }
    init() { this.setupNumberInput(true, {precision: 3}); }
}


class MoneyField extends FloatField {
    static keyName() { return 'money'; }
    init() { this.setupNumberInput(true, {}, ['precision']); }
}


class SelectField extends Field {
    static keyName() { return 'select'; }
    getValue() {
        return { value: this.elem[0].value, text: this.elem[0].itemText };
    }
    setValue(v) { this.elem.val(v); }
    init() {
        let self = this;
        this.elem.focusin(function () {
            var $field = $(this).closest('div.field-div');
            self.elem.removeClass('err');
            $field.find(".error-text").hide();
        });
    }
    onChange(f) {
        let self = this;
        return this.elem.change(function (e) { f(self.elem[0]); });
    }
    getClearValue() { return this.getValue().value; }
    getExportValue() { return this.getValue().text; }
    reset(params) {
        params = params || {};
        if (!params.keepValue) {
            this.elem[0].reset(this.defaultValue);
        }
        if (!params.keepErrors) {
            this.clearErrors();
        }
    }
    static detect(elem) {
        return elem[0].tagName === 'DROPDOWN-SELECT';
    }
}


class RadioField extends Field {
    static keyName() { return 'radio'; }
    getValue() {
        var checkedElem = this.elem.find('input:checked');
        if (checkedElem.length > 0) {
            return { value: checkedElem[0].id, text: checkedElem.parent().find("label").text() };
        }
        return undefined;
    }
    setValue(v) { this.elem.find('input#' + v).prop("checked", true); }
    onChange(f) {
        let self = this;
        return this.elem.find('input').change(function (e) { f(self.elem[0]); });
    }
    getClearValue() { return this.getValue().value; }
    getExportValue() { return this.getValue().text; }
    static detect(elem) {
        return elem.find('.radio-elem').length > 0;
    }
}


class CheckboxField extends Field {
    static keyName() { return 'checkbox'; }
    getValue() { return this.control.checked; }
    setValue(v) {this.control.checked = v; }
    init() {
        this.control = this.elem.find('input[type="checkbox"]')[0];
    }
    onChange(f) {
        let self = this;
        return this.elem.find('input[type="checkbox"]').change(function (e) {f(self.elem[0]); });
    }
    static detect(elem) {
        return elem.find('input[type="checkbox"]').length == 1;
    }
}

class TextField extends Field {
    static keyName() { return 'text'; }
    getClearValue() { return this.elem.val();}
    getValue() {
        const val = tools.removeExtraSpace(this.elem.val());
        return (this.options && this.options.raw ? val : tools.escapeTags(val));
    }
    setValue(v) { this.elem.val(v); }
    isFilled() { return false; }
}

class LinkField extends Field {
    static keyName() { return 'link'; }
    getValue() {
        const selectedLink = this.elem.find('a.selected-link');
        if (selectedLink.length > 0) {
            return selectedLink.data("type");
        }
        return undefined;
    }
    setValue(v) { this.elem.find(`a[data-type="${v}"]`).addClass("selected-link"); }
    init() {
        const self = this;
        this.elem.find('a').click(function (event) {
            event.preventDefault();
            self.elem.find('a').removeClass('selected-link');
            $(this).addClass('selected-link');
            return false;
        });
    }
    onChange(f) {
        let self = this;
        return this.elem.find('a').click(function (e) { f(self.elem[0]); });
    }
    getClearValue() { return this.getValue(); }
    getExportValue() { return this.getValue(); }
    reset(params) {
        this.elem.find('a').removeClass('selected-link');
        this.setValue(this.defaultGetValue);
    }
    static detect(elem) {
        return elem.find('a.selected-link').length > 0;
    }
}

const fields = [MoneyField, FloatField, SelectField, RadioField, CountField, YearField, PeriodField, CheckboxField, TextField, LinkField];

export { fields, Field, _BaseObjectField, RadioField, TextField, FloatField };
